import { SummaryCardRequestESG } from 'modules/ESG';
import React, { FC } from 'react';
import { Loader } from 'ui';
import { useGetAvailability } from '../services/esgSentiment';
import { ESGSentimentTabProps } from '../types/esgSentiment';
import { ESGSentiment } from './ESGSentiment';

export const ESGSentimentTab: FC<ESGSentimentTabProps> = ({ id, industry, countryCode }) => {
  const { data, loading, refetch } = useGetAvailability(id);

  if (loading) {
    return <Loader center />;
  }

  if (!data?.hasCompany || !data.hasPermission || !data.hasScore) {
    return (
      <SummaryCardRequestESG
        type="sentiment"
        scopeoneId={id}
        dataExists={data?.hasScore}
        isSubscribed={data?.hasPermission}
        isAvailable={data?.hasCompany}
        requestState={data?.requestState}
        industry={industry}
        countryCode={countryCode}
        onRequested={refetch}
        onUnlocked={refetch}
      />
    );
  }

  return <ESGSentiment />;
};
